import { ApolloError, useQuery } from '@apollo/client'
import { TAG_HISTORY_OF_EMPLOYEE_UNTIL_REPLY_ENTRY_DATE } from '../Queries'
import {
  TagHistoryOfEmployeeUntilReplyEntryDateQuery,
  TagHistoryOfEmployeeUntilReplyEntryDateQueryVariables,
  EmployeeTagType,
} from '../../../types'

type TagHistoryOfEmployeeUntilReplyEntryDateHookVariables = {
  employeeId: string
  types?: EmployeeTagType[]
}

export default (
  employeeId: string,
  types?: EmployeeTagType[],
): {
  data: TagHistoryOfEmployeeUntilReplyEntryDateQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const variables: TagHistoryOfEmployeeUntilReplyEntryDateHookVariables = {
    employeeId: employeeId,
    types: types,
  }

  const { data, error, loading } = useQuery<
    TagHistoryOfEmployeeUntilReplyEntryDateQuery,
    TagHistoryOfEmployeeUntilReplyEntryDateQueryVariables
  >(TAG_HISTORY_OF_EMPLOYEE_UNTIL_REPLY_ENTRY_DATE, {
    variables: variables,
  })

  return { data, error, loading }
}
